import React, { createContext, useEffect, useState } from "react";
import { ISearchResult, SearchItem } from "../types/search-engine.types";
import { FuseAdapter } from "../adapters/fuse-adapter";
import { searchRegistry } from "../register/search-registry";
import "../register/register-modules";

interface ContextType {
    search: (q: string) => ISearchResult
}

export const SearchContext = createContext<ContextType | null>(null);
export const SearchProvider: React.FC<{
    children: React.ReactNode;
    userRoles: string[];
}> = ({children, userRoles}) => {
    const [engine] = useState(() => new FuseAdapter());
    const [items, setItems] = useState<SearchItem[]>([]);
    const [quickLinks, setQuickLinks] = useState<SearchItem[]>([]);

    const hasAccess = (item: SearchItem) => {
        if (!item.permissions || item.permissions.length === 0) return true;

        return item.permissions.some(role =>
            userRoles.includes(role)
        );
    };

    useEffect(() => {
        const allItems = searchRegistry.getAll();
        const accessibleItems = allItems.filter(hasAccess);

        setItems(accessibleItems);
        setQuickLinks(accessibleItems.filter(i => i.type === "quickLink"));

        engine.index(accessibleItems);
    }, [engine, userRoles]);

    const search = React.useCallback((query: string): ISearchResult => {
        if (!query) {
            return {
                quickLinks,
                results: []
            };
        }

        const searchResult = engine.search(query, quickLinks);

        return {
            quickLinks: searchResult.quickLinks,
            results: searchResult.results
        };
    }, [engine, quickLinks]);

    return (
        <SearchContext.Provider value={{search}}>
            {children}
        </SearchContext.Provider>
    );
};
